import script from "./TabsWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__